module.exports = __webpack_public_path__ + "img/eye.aca62dfe.svg";